class FreeShipping extends SearchForm {
  constructor() {
    super();
    /* Aventus 3.9 (17 Oct 2026): the bar and the "Gasta X más" text now follow the same rules
       checkout uses, worked out from the cart lines cart.liquid renders (no extra cart.js fetch,
       so the right amount shows straight away instead of flashing the MX$900 one first).

       Shipping-rate rule (Settings > Shipping): data-threshold, in the cart's own currency,
       compared with the cart total (MX$900, US$100, AED 10 inside the UAE, AED 399 rest of GCC).

       Automatic free-shipping discounts (Discounts) are set in USD, the store currency, and
       checkout converts them with the market's exchange rate, so they are converted here with
       Shopify.currency.rate and rounded up to the whole peso:
       - "Suscripción: envío gratis desde $750 MXN": Mexico, subscription items, subtotal >= US$41.
         Counted on the subscription lines only (the safe reading for mixed carts).
       - "Promo Sandía: envío gratis desde $880 MXN": Mexico, one-time items, subtotal >= US$45,
         until 2026-10-19 06:00 UTC. Counted on the one-time lines only.
       Whichever rule is closest to being met drives the message and the bar. If the discounts
       change in Shopify admin, update AV_FS_DISCOUNTS below.

       Aventus 4.3.4 (19 Oct 2026), Mark: "fix all the wrong-language text" (adhoc-20261019-lang-p2): in Mexico the
       amount showed as "342,00 MXN" (Spain-style comma, no $). MXN amounts are now written like the rest of the site:
       "$342.00 MXN" (the sentence itself is the theme translation "Te faltan ... para el envío gratis").
       The amount is still the checkout's real rule (one-time MX$900; subscription US$41 converted, about MX$767 today).
       Undo: restore this file from theme 4.3.3. */
    this.amount = parseInt(this.dataset.amount);
    this.threshold = parseInt(this.dataset.threshold);
    this.met = this.querySelector('[data-free-shipping="true"]');
    this.unmet = this.querySelector('[data-free-shipping="false"]');
    this.amountText = this.querySelector('[data-amount]');

    FreeShipping.injectStyles();
    this.applyDiscountRules();
    this.render();
    this.classList.add('free-shipping--active');
  }

  applyDiscountRules() {
    var rules = FreeShipping.AV_FS_DISCOUNTS;
    var country = this.dataset.country || (window.Shopify && Shopify.country) || '';
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
    if (!rate || isNaN(rate)) rate = 1;
    var lineTotals = {
      sub: parseInt(this.dataset.subAmount) || 0,
      once: parseInt(this.dataset.onceAmount) || 0
    };

    var best = { amount: this.amount, threshold: this.threshold };
    var bestGap = Math.max(0, this.threshold - this.amount);
    var now = Date.now();

    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.country !== country) continue;
      if (r.until && now >= Date.parse(r.until)) continue;
      var basis = lineTotals[r.basis];
      if (!basis) continue;
      var thr = Math.ceil((r.minShopCents * rate) / 100) * 100;
      var gap = Math.max(0, thr - basis);
      if (gap < bestGap) {
        bestGap = gap;
        best = { amount: basis, threshold: thr };
      }
    }

    this.amount = best.amount;
    this.threshold = best.threshold;
  }

  render() {
    var reached = this.amount >= this.threshold;
    if (this.met) this.met.setAttribute('aria-hidden', 'true');
    if (this.unmet) this.unmet.setAttribute('aria-hidden', 'true');

    if (reached) {
      if (this.met) this.met.removeAttribute('aria-hidden');
    } else {
      if (Shopify.currency.active && this.amountText) {
        const locale = document.documentElement.getAttribute('lang');
        const amount = (this.threshold - this.amount) / 100;
        if (Shopify.currency.active === 'MXN') {
          this.amountText.textContent = '$' + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' MXN';
        } else {
          this.amountText.textContent = new Intl.NumberFormat(locale, {
            locales: [`${locale}-${Shopify.country}`, `${locale}`],
            style: 'currency',
            currency: Shopify.currency.active,
          }).format(amount);
        }
      }
      if (this.unmet) this.unmet.removeAttribute('aria-hidden');
    }

    this.renderBar(reached);
  }

  /* Progress bar towards the free shipping threshold. The percentage comes from
     the same values the message uses, so the two always agree. The bar is
     decorative: the text above it already states how much is left, so it is
     hidden from screen readers to avoid announcing the same thing twice. */
  renderBar(reached) {
    if (!this.threshold || this.threshold <= 0) return;
    if (isNaN(this.amount) || isNaN(this.threshold)) return;

    var pct = Math.round((this.amount / this.threshold) * 100);
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;

    var wrap = this.querySelector('.fs-progress');
    var fill;
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.setAttribute('aria-hidden', 'true');
      fill = document.createElement('span');
      fill.className = 'fs-progress__fill';
      wrap.appendChild(fill);
      this.appendChild(wrap);
    } else {
      fill = wrap.querySelector('.fs-progress__fill');
    }
    wrap.className = 'fs-progress' + (reached ? ' fs-progress--met' : '');
    /* Width is set immediately rather than on the next animation frame, so the
       bar is always correct even if frames are throttled or animations never
       run. The CSS transition still smooths any later cart updates. */
    if (fill) fill.style.width = pct + '%';
  }

  static injectStyles() {
    if (document.getElementById('fs-progress-styles')) return;
    var css = [
      '.free-shipping .fs-progress{position:relative;display:block;width:100%;height:6px;margin-top:.5rem;border-radius:999px;background:#EEE3E2;overflow:hidden;}',
      '.free-shipping .fs-progress__fill{display:block;height:100%;border-radius:999px;background:linear-gradient(90deg,#DE989E 0%,#C75D66 100%);transition:width .6s cubic-bezier(.4,0,.2,1);}',
      '.free-shipping .fs-progress--met .fs-progress__fill{background:linear-gradient(90deg,#C75D66 0%,#5A4448 100%);}',
      '@media (prefers-reduced-motion: reduce){.free-shipping .fs-progress__fill{transition:none;}}'
    ].join('');
    var style = document.createElement('style');
    style.id = 'fs-progress-styles';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }
}

/* Automatic free-shipping discounts, mirrored from Shopify admin > Discounts (17 Oct 2026).
   minShopCents is the discount's minimum subtotal in USD cents (the store currency). */
FreeShipping.AV_FS_DISCOUNTS = [
  { name: 'Suscripción: envío gratis desde $750 MXN', country: 'MX', basis: 'sub', minShopCents: 4100 },
  { name: 'Promo Sandía: envío gratis desde $880 MXN', country: 'MX', basis: 'once', minShopCents: 4500, until: '2026-10-19T06:00:00Z' }
];

customElements.define('free-shipping', FreeShipping);